/**
 * Creates a Load More button into the supplied Document using given markup.
 */
export default class LoadMoreButton {
  constructor(private doc: Document, private loadMoreMarkup: string) {}

  /**
   * Places the button in the document and creates an event listener with cb
   */
  public createElement(
    cb: (el: HTMLElement, ev: MouseEvent) => void
  ): HTMLElement {
    const el = this.doc.createElement('div');
    el.classList.add('lmp-load-more-container');
    el.innerHTML = this.loadMoreMarkup;
    el.addEventListener('click', (ev: MouseEvent) => {
      cb(el, ev);
    });
    return el;
  }
}
